import { MAuth } from '../../models/auth.model'
import { AuthActionTypes } from './auth.action-types'

const initialStates = {
    countries: [],
    states: [],
    cities: [],
    PR: {
        countries: [],
        states: [],
        cities: [],
    },
    POB: {
        countries: [],
        states: [],
        cities: [],
    },
    dynamicReground: {
        countries: [],
        states: [],
        cities: [],
    },
}

const TempAuthReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case AuthActionTypes.GET_COUNTRIES:
            return {
                ...state,
                countries: action.payload,
            }
        case AuthActionTypes.GET_STATES:
            return {
                ...state,
                states: action.payload,
            }
        case AuthActionTypes.GET_CITIES:
            return {
                ...state,
                cities: action.payload,
            }
        case AuthActionTypes.GET_PR_COUNTRIES:
            return {
                ...state,
                PR: {
                    ...state.PR,
                    countries: action.payload,
                },
            }
        case AuthActionTypes.GET_PR_STATES:
            return {
                ...state,
                PR: {
                    ...state.PR,
                    states: action.payload,
                },
            }
        case AuthActionTypes.GET_PR_CITIES:
            return {
                ...state,
                PR: {
                    ...state.PR,
                    cities: action.payload,
                },
            }
        case AuthActionTypes.GET_POB_COUNTRIES:
            return {
                ...state,
                POB: {
                    ...state.POB,
                    countries: action.payload,
                },
            }
        case AuthActionTypes.GET_POB_STATES:
            return {
                ...state,
                POB: {
                    ...state.POB,
                    states: action.payload,
                },
            }
        case AuthActionTypes.GET_POB_CITIES:
            return {
                ...state,
                POB: {
                    ...state.POB,
                    cities: action.payload,
                },
            }

        // dynamic PR
        case AuthActionTypes.GET_DYNAMIC_PR_COUNTRIES:
            return {
                ...state,
                dynamicReground: {
                    ...state.dynamicReground,
                    countries: action.payload,
                },
            }
        case AuthActionTypes.GET_DYNAMIC_PR_STATES:
            return {
                ...state,
                dynamicReground: {
                    ...state.dynamicReground,
                    states: action.payload,
                },
            }
        case AuthActionTypes.GET_DYNAMIC_PR_CITIES:
            return {
                ...state,
                dynamicReground: {
                    ...state.dynamicReground,
                    cities: action.payload,
                },
            }
        // end dynamic
        default:
            return state
    }
}

export default TempAuthReducer
